import { SET_VENOM_TEST_HEADER } from './constants';

/**
 * @typedef {Object<string, string|number>} Headers
 */

/**
 * SET_VENOM_TEST_HEADER action definition
 *
 * @param {Headers} payload
 * @returns {{type: string, payload: Headers}}  SET_VENOM_TEST_HEADER action definition
 */
export function setVenomTestHeader(payload) {
  return {
    type: SET_VENOM_TEST_HEADER,
    payload,
  };
}
